/*
  Subscribe and save cards (snippets/nr-subscribe-options.liquid). The radios
  themselves send selling_plan with the product form; this only:

  - marks the chosen card, and tells the Add to Cart price and the sticky bar
    (nr:offer-change) so they show its price;
  - with "How often" on, puts the chosen plan in the subscribe radio and
    shows its price and wording;
  - redraws the cards from Dawn's fresh section when the variant changes,
    since each variant has its own plans (or none).
*/
if (!customElements.get('nr-subscribe')) {
  customElements.define(
    'nr-subscribe',
    class NrSubscribe extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onChange.bind(this));
      }

      connectedCallback() {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !this.unsubscribe) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data?.sectionId !== this.dataset.sectionId || !event.data.html) return;
            const fresh = event.data.html.querySelector(`nr-subscribe[data-section-id="${this.dataset.sectionId}"]`);
            this.innerHTML = fresh ? fresh.innerHTML : '';
            this.announce();
          });
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        this.unsubscribe = null;
      }

      onChange(event) {
        const select = event.target.closest('[data-nr-sub-select]');
        if (select) {
          const option = select.selectedOptions[0];
          const card = select.closest('.nr-subscribe__option');
          const radio = card.querySelector('.nr-subscribe__input');
          radio.value = select.value;
          radio.checked = true;
          const price = card.querySelector('[data-nr-sub-price]');
          if (price && option.dataset.price) price.textContent = option.dataset.price;
          const was = card.querySelector('[data-nr-sub-was]');
          if (was) {
            was.textContent = option.dataset.was || '';
            was.hidden = !option.dataset.was;
          }
          card.querySelectorAll('[data-nr-sub-text]').forEach((text) => {
            text.hidden = text.dataset.nrSubText !== select.value;
          });
        }
        if (!event.target.matches('.nr-subscribe__input') && !select) return;
        this.querySelectorAll('.nr-subscribe__option').forEach((card) => {
          card.classList.toggle('is-selected', !!card.querySelector('.nr-subscribe__input:checked'));
        });
        this.announce();
      }

      announce() {
        this.dispatchEvent(new CustomEvent('nr:offer-change', { bubbles: true }));
      }
    }
  );
}
